<template>
    <div class="save-container">
        <slot />

        <el-popover
            v-model="visible"
            placement="top"
            width="240"
        >
            <p class="popover-text"><i class="el-icon-question popover-icon popper-text" />{{ $t('button.AreYouSureToSaveThis') }}</p>
            <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visible = false">{{ $t('button.Cancel') }}</el-button>
                <el-button type="primary" size="mini" :loading.sync="isLoadingIcon" @click="confirm()">{{ $t('button.Confirm') }}</el-button>
            </div>
            <el-button slot="reference" size="small" type="primary">{{ $t('button.Save') }}</el-button>
        </el-popover>
    </div>
</template>

<script>
export default {
    props: {
        isLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            visible: false,
        };
    },
    computed: {
        isLoadingIcon: {
            get() {
                return this.isLoading;
            },
            set(value) {
                this.$emit("update:isLoading", value);
            }
        }
    },
    methods: {
        confirm() {
            this.visible = false;
            this.$emit("confirmSave");
        }
    },
};
</script>

<style lang="css" scoped>
.popover-icon {
    color: #ff9900;
}
.popper-text {
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Button/SaveButton.vue